// Localizacoes.js
// FINAL DE LINHAs fixos (terminais, garagens, bairros etc.) para uso no mapa de tráfego

export const LOCALIZACOES_FIXAS = [
  {
    id: 'TERMINAL_5',
    nome: 'TERMINAL 5',
    latitude: -3.07498,
    longitude: -59.95538,
    tipo: 'TERMINAL',
  },
  {
    id: 'VIA_NORTE',
    nome: 'VIA NORTE',
    latitude: -3.00087,
    longitude: -60.00281,
    tipo: 'FINAL DE LINHA',
  },
  {
    id: 'VIVER_MELHOR',
    nome: 'VIVER MELHOR',
    latitude: -2.96314,
    longitude: -59.98715,
    tipo: 'FINAL DE LINHA',
  },
  {
    id: 'BAIRRO_DA_PAZ',
    nome: 'BAIRRO DA PAZ',
    latitude: -3.06232,
    longitude: -60.03436,
    tipo: 'FINAL DE LINHA',
  },
  {
    id: 'TERMINAL_4',
    nome: 'TERMINAL 4',
    latitude: -3.03504,
    longitude: -59.94447,
    tipo: 'TERMINAL',
  },
  {
    id: 'GALILEIA',
    nome: 'GALILÉIA',
    latitude: -3.014729881897205,
    longitude: -59.987838491956666,
    tipo: 'FINAL DE LINHA',
  },
  {
    id: 'TERMINAL_3',
    nome: 'TERMINAL 3',
    latitude: -3.03149,
    longitude: -59.9857,
    tipo: 'TERMINAL',
  },
  {
    id: 'UNIAO_DA_VITORIA',
    nome: 'UNIÃO DA VITÓRIA',
    latitude: -2.975773373739407,
    longitude: -60.033583567314345,
    tipo: 'FINAL DE LINHA',
  },
  {
    id: 'GARAGEM_EXPRESSO',
    nome: 'EXPRESSO COROADO',
    latitude: -3.076893,
    longitude: -59.983316,
    tipo: 'EMPRESA',
    cor: '#F37736',
  },
  {
    id: 'NOVA_CIDADE',
    nome: 'NOVA CIDADE',
    latitude: -3.00192,
    longitude: -59.98332,
    tipo: 'FINAL DE LINHA',
  },
  {
    id: 'GARAGEM_VEGA',
    nome: 'VEGA',
    latitude: -3.017964,
    longitude: -60.058261,
    tipo: 'EMPRESA',
    cor: '#01CDFE',
  },
  {
    id: 'PARQUE_SAO_PEDRO',
    nome: 'PARQUE SÃO PEDRO',
    latitude: -3.00297,
    longitude: -60.03406,
    tipo: 'FINAL DE LINHA',
  },
  {
    id: 'VIVENDA_VERDE',
    nome: 'VIVENDA VERDE',
    latitude: -2.978324,
    longitude: -60.100026,
    tipo: 'FINAL DE LINHA',
  },
  {
    id: 'GARAGEM_INTEGRAÇÃO',
    nome: 'INTEGRAÇÃO',
    latitude: -3.027601,
    longitude: -59.958616,
    tipo: 'EMPRESA',
    cor: '#FF0000',
  },
  {
    id: 'AJURICABA',
    nome: 'AJURICABA',
    latitude: -3.0651966811285574,
    longitude: -60.04356875782366,
    tipo: 'FINAL DE LINHA',
  },
  {
    id: 'GARAGEM_VIA_VERDE',
    nome: 'VIA VERDE',
    latitude: -3.074028,
    longitude: -60.06282,
    tipo: 'EMPRESA',
    cor: '#00B159',
  },
  {
    id: 'HILEIA',
    nome: 'HILÉIA',
    latitude: -3.0480609093471873,
    longitude: -60.045424996203465,
    tipo: 'FINAL DE LINHA',
  },
  {
    id: 'MANOA',
    nome: 'MANOA',
    latitude: -3.0201981969989613,
    longitude: -59.993827402376034,
    tipo: 'FINAL DE LINHA',
  },
  {
    id: 'BAIRRO_DA_UNIAO',
    nome: 'BAIRRO DA UNIÃO',
    latitude: -3.07505,
    longitude: -60.01433,
    tipo: 'FINAL DE LINHA',
  },
  {
    id: 'CJ_RIO_MARACANA',
    nome: 'CJ RIO MARACANÃ',
    latitude: -3.05471,
    longitude: -60.01869,
    tipo: 'FINAL DE LINHA',
  },
  {
    id: 'BEIJA_FLOR',
    nome: 'BEIJA - FLOR',
    latitude: -3.04506,
    longitude: -60.00798,
    tipo: 'FINAL DE LINHA',
  },
  {
    id: 'SANTA_ETELVINA',
    nome: 'SANTA ETELVINA',
    latitude: -2.98907,
    longitude: -60.01561,
    tipo: 'FINAL DE LINHA',
  },
  {
    id: 'MATRIZ',
    nome: 'MATRIZ',
    latitude: -3.13557859560837,
    longitude: -60.027434925139126,
    tipo: 'FINAL DE LINHA',
  },
  {
    id: 'TERMINAL_7',
    nome: 'TERMINAL 7',
    latitude: -2.992926,
    longitude: -60.031217,
    tipo: 'TERMINAL',
  },
  {
    id: 'GARAGEM_LÍDER',
    nome: 'LÍDER',
    latitude: -2.970925,
    longitude: -60.002097,
    tipo: 'EMPRESA',
    cor: '#7BC043',
  },
  {
    id: 'GARAGEM_GLOBAL',
    nome: 'GLOBAL',
    latitude: -3.075941,
    longitude: -59.955389,
    tipo: 'EMPRESA',
    cor: '#F9D62E',
  },
  {
    id: 'GARAGEM_SAO_PEDRO',
    nome: 'SAO PEDRO',
    latitude: -2.977154,
    longitude: -60.054477,
    tipo: 'EMPRESA',
    cor: '#0392CF',
  },
];
